import moment from 'moment';
import type { GetPaymentResponseRequest } from './cash-processor.interface';

const mockExpirationByOperation = new Map<string, string>();

export function buildMockCashProcessorPayment(
  operationId?: string,
  merchantId?: string,
): GetPaymentResponseRequest {
  const cacheKey = `${merchantId ?? 'merchant'}-${operationId ?? 'operation'}`;

  if (!mockExpirationByOperation.has(cacheKey)) {
    mockExpirationByOperation.set(
      cacheKey,
      moment().add(3, 'days').format('YYYY-MM-DD HH:mm:ss'),
    );
  }

  return {
    code: 'OK',
    errorMsg: null,
    paymentCode: operationId ?? '11233542',
    status: 'PENDIENTE_PAGO',
    expiration: mockExpirationByOperation.get(cacheKey)!,
    merchant: 'Monnet CO',
    amount: '1000.00',
    currencyCode: 'COP',
    currencyISO: '$',
    operationNumber: '21715292',
    exchangeConfig: null as unknown as undefined,
    voucherConfig:
      '{"version":"V1","bankList":[{"bankCode":"EFECTY","hexColor":"#FEDA01","paymentMethodInstructions":[{"method":"Cash","instructions":[{"order":1,"value":"\\u003cstrong\\u003eAcércate a cualquier punto Efecty e indica que deseas pagar el servicio de recaudo \\u003ca class \\u003d \\"purple-text\\"\\u003eMONNET PAGOS.\\u003c/a\\u003e\\u003c/strong\\u003e"},{"order":2,"value":"\\u003cstrong\\u003eIndica el código de convenio de \\u003ca class\\u003d\\"purple-text\\"\\u003eCLINNG 435698.\\u003c/a\\u003e\\u003c/strong\\u003e"},{"order":3,"value":"\\u003cstrong\\u003eIndica tu código de pago  \\u003ca class\\u003d\\"purple-text\\"\\u003e11233542\\u003c/a\\u003e\\u003c/strong\\u003e"},{"order":4,"value":"\\u003cstrong\\u003eIndica el monto total a pagar, cancela y ¡listo! el pago se procesará automáticamente\\u003c/strong\\u003e"}]}]}],"instruction_payment_methods":["Cash"]}' as unknown as GetPaymentResponseRequest['voucherConfig'],
    showReturnBtn: false,
    tokenCr:
      'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIyMTcxNTI5MiIsImlhdCI6MTc4MDk0NzQwNywiZXhwIjoxNzgwOTUxMDA3fQ.5QQ7oOCLI2CYuZduZ_666TMIBLpqsMGkSZWKvVbV_uc',
    countryCode: 'COL',
  };
}
